import React, { useMemo } from 'react'
import { Box, Icon } from '@maui/elements'
import { SearchResultDescription, SearchResultHeader, SearchResultTitle, useMemoizedDescription } from '../common'
import { MotivationsPill, TargetedIndustriesPill } from './ActorSearchResult'

const formatReports = (data) => {
  return {
    ...data,
    name: data.title,
    date: data.publish_date || data.publishDate,
    reportType: data.report_type || data.reportType,
    reportId: data.report_id || data.reportId,
    executiveSummary: data.executive_summary,
    isightComment: data.isightComment,
    tags: data.tags
      ? Object.entries(data.tags).map(tag => {
        return {
          name: tag[0],
          values: tag[1]
        }
      })
      : []
  }
}

export const ReportSearchResult = ({ data }) => {
  const formattedData = useMemo(() => {
    if (!data) return
    return formatReports(data)
  }, [data])

  const {
    name,
    reportType,
    reportId,
    date,
    executiveSummary,
    isightComment,
    tags
  } = formattedData
  const memoizedDescription = useMemoizedDescription(executiveSummary, isightComment)
  return (
    <Box>
      <SearchResultHeader subHeaderText={`Report | ${reportType} | ${reportId}`} date={date} />
      <SearchResultTitle
        titleIcon={<Icon name='blank-paper' size='lg' verticalAlign='-12.7px'/>}
        name={name}
        url={`/reports/${reportId}`}
      />
      <Box pt='8px' pb='8px'>
        <Box display='flex'>
          <Box>
            {tags.map((tag, i) => {
              const { name, values = [] } = tag
              if (name === 'industries') {
                return <TargetedIndustriesPill key={i} industries={values}/>
              }
              if (name === 'motivations') {
                return <MotivationsPill key={i} motivations={values}/>
              }
              return null
            })}
          </Box>
        </Box>
      </Box>
      <SearchResultDescription description={memoizedDescription}/>
    </Box>
  )
}
